import { useNavigationType } from 'react-router-dom';

/**
 * Returns false on back/forward navigation (POP) so motion components
 * skip their entry animations. Returns true on fresh navigations (PUSH/REPLACE).
 */
export function usePageAnimation() {
  return useNavigationType() !== 'POP';
}
